import React, { FC } from 'react'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import Icon from '@ucheba/ui/icons/icon__check_circle-outline.svg'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import styled from 'styled-components'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { IForWhomProgram } from '../types'

const HeadCol = styled.div`
  display: flex;
`

const HeadColIcon = styled.div`
  width: 20px;
  margin-right: 8px;
`

const HeadColTitle = styled.div`
  flex: 1;
`

const ForWhomProgram: FC<IForWhomProgram> = (props) => {
  const { suitableForList } = props

  if (!suitableForList || suitableForList.length === 0) return null

  return (
    <div>
      <Heading h3='Кому подойдет программа' spacing='small' />

      <Grid>
        {suitableForList.map((item, key) => (
          <GridCol key={key} uxs={12}>
            <HeadCol>
              <HeadColIcon>
                <Icon color='blue' width='20px' height='20px' />
              </HeadColIcon>

              <HeadColTitle>
                <Text fontSize='h4' lineHeight='h4' fontWeight='bold'>
                  {item.name}
                </Text>
              </HeadColTitle>
            </HeadCol>

            <Spacing spacing='xxsmall' />

            <Text firstLetterUppercase>{item.description}</Text>
          </GridCol>
        ))}
      </Grid>
    </div>
  )
}

export default ForWhomProgram
